
const { useQuery, useLazyQuery, gql, useMutation } = require("@apollo/client");

function IntransitPODProcessTable({
  formik,
  name,
  handleRowDelete,
  onTransactionChange,
  el,
  dropDownData,
  tablerow,
  onPaymentChange,
  handlePaymentDelete,
  headers,
}) {


  return (
    <>
      <tr className="" key={el.id}>
        {headers?.map((e, i) => {
         
          return <td className="paymentProcessRow">{el[e]}</td>;
        })}
      </tr>
      <></>
    </>
  );
}

export default IntransitPODProcessTable;
